import Icon from '../components/shared/IconBase'

const ArrowNext = (props) => (
    <Icon width="6" height="12" viewBox="0 0 6 12" {...props}>
        <path d="M0.878279 11.5L0.00618506 10.6091L4.51509 5.99684L0 1.39087L0.872094 0.5L5.82014 5.55457C6.05995 5.801 6.05995 6.199 5.82014 6.44543L0.878279 11.5Z" fill={props.fill}/>
    </Icon>
)

export default ArrowNext
